<div #resizer class="resizer">
  <mat-icon [ngClass]="{ hidden: (resizing$ | async) === false }">texture</mat-icon>
</div>
